import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { Dispatch, useCallback, useEffect, useState } from 'react';
import Career from 'wwg-utilities/dist/collections/career';
import getCareersRequest from '../../../lib/api/getCareersRequest';
import LoadingCards from '../../shared/LoadingCards';
import LoadMoreButton from '../../shared/LoadMoreButton';
import CareerCard from '../CareerCard';

interface CareerGuideResultsProps {
  page: number;
  setPage: Dispatch<number>;
}

const CareerGuideResults: React.FC<CareerGuideResultsProps> = ({
  page,
  setPage,
}) => {
  const router = useRouter();

  const [isComplete, setIsComplete] = useState(false);

  const [careerResults, setCareerResults] = useState([] as Career[]);

  const { data, isFetching } = useQuery(
    ['wwg-careers', JSON.stringify(router.query), page],
    () => {
      return getCareersRequest({
        ...(router.query as any),
        page,
        catalog: 'all',
      });
    },
  );

  useEffect(() => {
    if (data) {
      let results = [...careerResults];
      if (data?.length < 20) {
        setIsComplete(true);
      } else {
        setIsComplete(false);
      }
      if (page == 1) {
        results = [...data];
      } else {
        results.push(...data);
      }
      setCareerResults(results);
    } else {
      setIsComplete(true);
    }
  }, [data]);

  const nextPage = useCallback(() => {
    setPage(page + 1);
  }, [page]);

  return (
    <>
      <section className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-rows-auto ">
        {Boolean(careerResults && careerResults.length) &&
          careerResults?.map((career: Career) => {
            return <CareerCard key={career.id} career={career} />;
          })}
        {isFetching && <LoadingCards />}
      </section>
      <div className="container mx-auto">
        <LoadMoreButton color='careerPageHighlight' isComplete={isComplete} nextPage={nextPage} />
      </div>
    </>
  );
};

export default CareerGuideResults;
